import { render, staticRenderFns } from "./ReportCheckManager2.vue?vue&type=template&id=f0513890&scoped=true&"
import script from "./ReportCheckManager2.vue?vue&type=script&lang=js&"
export * from "./ReportCheckManager2.vue?vue&type=script&lang=js&"
import style0 from "./ReportCheckManager2.vue?vue&type=style&index=0&id=f0513890&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0513890",
  null
  
)

export default component.exports